<template>
  <div
    class="aside-menu-item"
    :class="{ selected: moduleSelected, _tooltip: module.name.length > 22 }"
  >
    <div
      class="menu-item d-flex justify-content-between align-items-center px-3 py-2"
      :class="{ blocked: isBlocked }"
      @click="selectItem"
      @mouseover="hoverItem"
      @mouseleave="leaveItem"
    >
      <div class="d-flex align-items-center">
        <i class="icon-book" />
        <div class="label ml-3 pl-1 mb-0">
          {{ label }}
          <span
            v-if="module.name.length > 22"
            :id="`${module.id}-tooltip`"
            class="_tooltip px-2 py-1"
          >
            {{ module.name }}
          </span>
        </div>
      </div>
      <i v-if="isBlocked" class="icon-lock" />
      <i v-else-if="items.length" class="icon-chevron-down" />
    </div>

    <div class="menu-subitems">
      <div class="wrapper">
        <template v-for="(item, i) in items">
          <div
            v-if="item.type == 'lesson'"
            :key="`lesson-${i}`"
            class="px-4 py-2"
            :class="{ selected: $route.params.lesson == item.id }"
            @click="selectLesson(item)"
          >
            <label>{{ item.name }}</label>
          </div>
          <div
            v-if="item.type == 'quiz'"
            :key="`quiz-${i}`"
            class="px-4 py-2"
            :class="{ selected: $route.params.quiz == item.code }"
            @click="selectQuiz(item)"
          >
            <label>{{ item.name }}</label>
          </div>
        </template>
        <div
          v-for="(submodule, i) in submodules"
          :key="`submodule-${i}`"
          class="px-4 py-2"
          :class="{ selected: $route.params.id == submodule.id }"
          @click="selectSubmodule(submodule)"
        >
          <label>{{ submodule.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { calculateTimeFromNow } from "@/functions/helpers";
import get from "lodash/get";
export default {
  props: {
    module: {
      type: Object,
      required: true
    },
    selectedItem: {
      type: String,
      required: true
    }
  },
  computed: {
    items() {
      return [...this.module.items].sort((a, b) => a.sort - b.sort);
    },
    submodules() {
      return this.module.sub_modules;
    },
    moduleSelected() {
      return (
        this.$route.params.id == this.module.id ||
        this.submodules.find(
          submodule => submodule.id == this.$route.params.id
        ) ||
        this.selectedItem == this.module.id
      );
    },
    isBlocked() {
      const blocked = get(this.module, "is_blocked.status");
      const diff = calculateTimeFromNow(get(this.module, "release_at", ""));
      const is_released = diff && diff < 1;
      return blocked || is_released;
    },
    label() {
      return this.module.name.length > 22
        ? `${this.module.name.slice(0, 22)}...`
        : this.module.name;
    }
  },
  methods: {
    hoverItem(e) {
      const parent_position = e.target.getBoundingClientRect();
      if (this.module.name.length > 22) {
        const tooltip = document.getElementById(`${this.module.id}-tooltip`);
        tooltip.style.position = "fixed";
        tooltip.style.top = `${parent_position.top + 20}px`;
        tooltip.style.left = `${parent_position.left - 20}px`;
      }
    },
    leaveItem(e) {
      const parent_position = e.target.getBoundingClientRect();
      if (this.module.name.length > 22) {
        const tooltip = document.getElementById(`${this.module.id}-tooltip`);
        tooltip.style.top = `${parent_position.top - 20}px`;
        tooltip.style.position = "absolute";
      }
    },
    selectItem() {
      if (this.items.length || this.submodules.length) {
        this.$emit("selectItem", this.module);
      } else {
        this.$router.push({ name: "module", params: { id: this.module.id } });
        this.$emit("close");
      }
    },
    selectLesson(lesson) {
      this.$router.push({
        name: "lesson",
        params: { id: this.module.id, lesson: lesson.id }
      });
      this.$emit("close");
    },
    selectSubmodule(submodule) {
      this.$router.push({ name: "module", params: { id: submodule.id } });
      this.$emit("close");
    },
    selectQuiz(quiz) {
      this.$router.push({
        name: "lesson-quiz",
        params: {
          id: this.module.id,
          quiz: quiz.code
        }
      });
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.aside-menu-item {
  position: relative;
  white-space: nowrap;
  &.selected {
    .menu-subitems {
      grid-template-rows: 1fr;
    }
    .icon-chevron-down {
      transform: rotate(180deg);
    }
  }

  .menu-item {
    cursor: pointer;
    i {
      &.icon-book {
        font-size: 22px;
      }
      &.icon-lock {
        font-size: 14px;
      }
      &.icon-chevron-down {
        font-weight: 900;
        transition: 0.2s all;
      }
    }
    .label {
      font-size: 14px;
      position: relative;
      ._tooltip {
        top: 30px;
        left: 20px;
        opacity: 0;
        z-index: 10;
        font-size: 12px;
        position: absolute;
        border-radius: 4px;
        pointer-events: none;
      }
      &:hover {
        ._tooltip {
          opacity: 1;
        }
      }
    }
    &.blocked {
      pointer-events: none;
    }
  }
  .menu-subitems {
    display: grid;
    margin-left: 27px;
    position: relative;
    transition: 0.2s all;
    grid-template-rows: 0fr;
    &::before {
      content: "";
      left: 0;
      top: 3px;
      width: 1px;
      position: absolute;
      height: calc(100% - 42px);
    }
    .wrapper {
      overflow: hidden;
      div {
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        &::before {
          left: 0;
          top: -30px;
          content: "";
          width: 50px;
          height: 50px;
          position: absolute;
          border-radius: 10px;
          clip-path: ellipse(20px 50px at 1% 90%);
        }
        &:hover {
          cursor: pointer;
        }
        label {
          display: inline;
          font-size: 14px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
